import React from "react";
import "../styles/components/buttonBar.css"

/**
 * Komponente, welche Buttons am Ende der Seite anzeigt
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function EAButtonBar(props) {
    const {children, className, ...rest} = props;
    const classes = className ? className + " ea-bb" : "ea-bb";
    return (<div className={classes} {...rest}>{children}</div>)
}

export default EAButtonBar;
